import styled from "@emotion/styled";

export const Root = styled.div({
    minWidth: 1000,
    marginLeft: 40,
    paddingTop: 20,
});
